import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { Query } from '../../../hooks/queries'
import { getTotalVulnerabilitiesPendingApprovalQuery } from './queries/get-total-vulnerabilities-pending-approval-query'
import { useReducer } from 'react'

interface State {
  pendingStatusTimestamp: number
  hasError: boolean
}

const getInitialState: () => State = () => ({
  pendingStatusTimestamp: Date.now(),
  hasError: false
})

export interface GetTotalPendingStatusTracesResponse {
  totalVulnerabilities: number
  pendingStatusTimestamp: number
}

type GetTotalPendingStatusTraces = (props: {
  organizationUuid: string
  enabled: boolean
}) => GetTotalPendingStatusTracesResponse

type ReducerAction =
  | {
      type: 'UPDATE_TIMESTAMP'
    }
  | { type: 'ERROR' }

const reducer = (state: State, action: ReducerAction) => {
  switch (action.type) {
    case 'UPDATE_TIMESTAMP':
      return {
        ...state,
        pendingStatusTimestamp: Date.now()
      }
    case 'ERROR':
      return {
        ...state,
        hasError: true
      }
  }
}

export const useGetTotalVulnerabilitiesPendingApproval: GetTotalPendingStatusTraces =
  ({ organizationUuid, enabled }) => {
    const [state, dispatch] = useReducer(reducer, getInitialState())
    const isEnabled = !state.hasError && enabled

    const { data } = useContrastQuery(
      [Query.VULN_APPROVAL_WORKFLOW_PENDING_STATUS, organizationUuid],
      getTotalVulnerabilitiesPendingApprovalQuery,
      {
        organizationUuid
      },
      {
        enabled: isEnabled,
        staleTime: 0,
        onError: (error) => {
          console.error(error)
          // Disable request if an error is returned
          dispatch({ type: 'ERROR' })
        },
        onSuccess: (onSuccessData) => {
          if (!!onSuccessData && onSuccessData.count > 0) {
            dispatch({ type: 'UPDATE_TIMESTAMP' })
          }
        }
      }
    )

    return {
      totalVulnerabilities: !!data ? data.count : 0,
      pendingStatusTimestamp: state.pendingStatusTimestamp
    }
  }
